import Main from './UserTrailStepsMain'

export default {
  Main,
}
